import React, { useEffect, useRef } from "react";

const FoliumMap = ({ htmlContent, height = "400px", width = "100%" }) => {
	const iframeRef = useRef(null);

	useEffect(() => {
		if (!htmlContent || !iframeRef.current) return;

		try {
			if (htmlContent.includes("<!DOCTYPE html>")) {
				// Complete HTML document - extract just the HTML part
				const htmlStart = htmlContent.indexOf("<!DOCTYPE html>");
				const cleanHtmlContent = htmlContent.substring(htmlStart);

				// Create a Blob
				const blob = new Blob([cleanHtmlContent], {
					type: "text/html",
				});

				// Convert to a blob URL
				const blobUrl = URL.createObjectURL(blob);

				// Assign to iframe
				iframeRef.current.src = blobUrl;
			} else {
				// Partial HTML content - wrap it in a complete document
				const wrappedContent = `
          <!DOCTYPE html>
          <html>
            <head>
              <meta charset="utf-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <script src="https://cdn.jsdelivr.net/npm/leaflet@1.9.3/dist/leaflet.js"></script>
              <script src="https://code.jquery.com/jquery-3.7.1.min.js"></script>
              <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.2.2/dist/js/bootstrap.bundle.min.js"></script>
              <script src="https://cdnjs.cloudflare.com/ajax/libs/Leaflet.awesome-markers/2.0.2/leaflet.awesome-markers.js"></script>
              <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/leaflet@1.9.3/dist/leaflet.css"/>
              <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.2/dist/css/bootstrap.min.css"/>
              <link rel="stylesheet" href="https://netdna.bootstrapcdn.com/bootstrap/3.0.0/css/bootstrap-glyphicons.css"/>
              <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@6.2.0/css/all.min.css"/>
              <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/Leaflet.awesome-markers/2.0.2/leaflet.awesome-markers.css"/>
              <link rel="stylesheet" href="https://cdn.jsdelivr.net/gh/python-visualization/folium/folium/templates/leaflet.awesome.rotate.min.css"/>
              <style>
                html, body { 
                  width: 100%; 
                  height: 100%; 
                  margin: 0; 
                  padding: 0; 
                }
                .folium-map { 
                  position: absolute; 
                  top: 0; 
                  bottom: 0; 
                  right: 0; 
                  left: 0; 
                }
                .leaflet-container { 
                  font-size: 1rem; 
                }
              </style>
            </head>
            <body>
              ${htmlContent}
            </body>
          </html>
        `;
				iframeRef.current.srcDoc = wrappedContent;
			}
		} catch (error) {
			console.error("Error loading map content:", error);
		}
	}, [htmlContent]);

	if (!htmlContent) {
		return <div>No map data available</div>;
	}

	return (
		<div
			style={{
				width,
				height,
				border: "1px solid #ccc",
				borderRadius: "4px",
			}}
		>
			<iframe
				ref={iframeRef}
				style={{
					width: "100%",
					height: "100%",
					border: "none",
					borderRadius: "4px",
				}}
				title="Folium Map"
				sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-modals"
				onLoad={() => console.log("Iframe loaded")}
				onError={(e) => console.error("Iframe error:", e)}
			/>
		</div>
	);
};

export default FoliumMap;
